// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MV0j","right":"styles_right__3YiNo"};